var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrowCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.617 24 24 18.617 24 12C24 5.38298 18.617 0 12 0C5.38298 0 0 5.38298 0 12C0 18.617 5.38298 24 12 24ZM8.29298 11.293L13.293 6.29302C13.488 6.09802 13.744 6 14 6C14.256 6 14.512 6.09802 14.707 6.29302C15.098 6.684 15.098 7.31601 14.707 7.707L10.414 12L14.707 16.293C15.098 16.684 15.098 17.316 14.707 17.707C14.316 18.098 13.684 18.098 13.293 17.707L8.29298 12.707C7.902 12.316 7.902 11.684 8.29298 11.293Z",
    fill: "#737AE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowCircle);
export default __webpack_public_path__ + "static/media/backArrowCircle.695a82ba37161567120576f6ae3b6ebf.svg";
export { ForwardRef as ReactComponent };